<template>
  <div class="plugins-xesalert-mask" v-if="show">
    <div class="xes-alert">
      <img
        v-show="hasCloseBtn"
        class="xes-alert-close-btn"
        src="https://editor.xesimg.com/tailor/resource/location-nav-close-btn%402x-1622208753169.png"
        alt=""
        @click="close"
      />
      <div class="xes-alert-title">{{ title }}</div>
      <div class="xes-alert-message" v-html="message"></div>
      <div class="xes-confirm-button" v-if="type === 'confirm'">
        <div class="xes-confirm-button-cancel" ref="cancelEl" @click="cancelHandle">
          {{ cancelText }}
        </div>
        <div class="xes-confirm-button-sure" ref="sureEl" @click="sureHandle">
          {{ sureText }}
        </div>
      </div>
      <div class="xes-alert-button" v-else>
        <div class="xes-alert-button-sure" ref="sureEl" @click="sureHandle">{{ sureText }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'XesAlert',
  data() {
    return {
      type: 'alert', // comfirm: 确认取消双按钮 alert: 单按钮
      title: '',
      message: 'message',
      onSure: '',
      onCancel: '',
      sureText: '确定',
      cancelText: '取消',
      show: false,
      hasCloseBtn: false
    }
  },
  methods: {
    cancelHandle() {
      this.show = false
      this.onCancel && this.onCancel()
    },
    sureHandle() {
      this.show = false
      this.onSure && this.onSure()
    },
    close() {
      this.show = false
    }
  }
}
</script>
<style lang="less" scoped>
.plugins-xesalert-mask {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;

  .xes-alert {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 320px;
    padding-bottom: 28px;
    background: rgba(255, 255, 255, 1);
    border-radius: 8px;
  }

  .xes-alert-close-btn {
    position: absolute;
    top: 12px;
    right: 12px;
    width: 16px;
    height: 16px;
  }

  .xes-alert-title {
    margin: 28px 0 10px;
    font-size: 21px;
    font-weight: 400;
    font-family: PingFangSC-Regular, PingFang SC;
    color: rgba(33, 40, 49, 1);
  }

  .xes-alert-message {
    padding: 0 25px;
    font-size: 15px;
    font-weight: 400;
    font-family: PingFang SC Regular, PingFang SC Regular-Regular;
    line-height: 43px/2;
    text-align: center;
    color: #5b6169;
  }

  .xes-confirm-button {
    display: flex;
    margin: 28px 0 0;

    .xes-confirm-button-sure {
      width: 126px;
      height: 65/2px;
      font-size: 14px;
      font-weight: 400;
      font-family: PingFangSC-Regular, PingFang SC;
      line-height: 65/2px;
      text-align: center;
      color: rgba(255, 255, 255, 1);
      background: rgba(235, 0, 42, 1);
      border-radius: 30px;
      // box-shadow: 0 4px 4px -2px rgba(255, 94, 80, 0.3);
    }

    .xes-confirm-button-cancel {
      width: 126px;
      height: 65/2px;
      margin-right: 16px;
      font-size: 14px;
      font-weight: 400;
      font-family: PingFangSC-Regular, PingFang SC;
      line-height: 65/2px;
      text-align: center;
      color: #212831;
      background: #f3f3f4;
      border-radius: 30px;
    }
  }

  .xes-alert-button {
    padding: 28px 0 0;

    .xes-alert-button-sure {
      width: 319/2px;
      height: 56/2px;
      font-weight: 400;
      line-height: 56/2px;
      text-align: center;
      color: #fff;
      background: #eb002a;
      border-radius: 28/2px;
    }
  }
}
</style>
